<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">编号</label>
            <em class="weui-form-preview__value">{{ form.main.vq_code }}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商名称</label>
            <div class="weui-form-preview__value weui-form-preview__value-icon">
              <span>{{ form.main.vq_vendname }}</span>
              <router-link :to="{path:'/ent/Information',query:{name:form.main.vq_vendname}}" class="iconfont icon-qichacha"></router-link>
            </div>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商类型</label>
            <span class="weui-form-preview__value">{{
              form.main.vq_type
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.vq_business">
            <label class="weui-form-preview__label">社会信用代码</label>
            <span class="weui-form-preview__value">{{
              form.main.vq_business
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.vq_legal_person">
            <label class="weui-form-preview__label">法人</label>
            <span class="weui-form-preview__value">{{
              form.main.vq_legal_person
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.vq_address">
            <label class="weui-form-preview__label">公司地址</label>
            <span class="weui-form-preview__value">{{
              form.main.vq_address
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.vq_bank">
            <label class="weui-form-preview__label">开户银行</label>
            <span class="weui-form-preview__value">{{
              form.main.vq_bank
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.vq_bank_account">
            <label class="weui-form-preview__label">银行账户</label>
            <span class="weui-form-preview__value">{{
              form.main.vq_bank_account
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">付款方式</label>
            <span class="weui-form-preview__value">
              {{ form.main.vq_payment }}
              <span v-if="form.main.vq_currency">{{
                form.main.vq_currency
              }}</span>
            </span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.vq_register_capita"
          >
            <label class="weui-form-preview__label">注册资金</label>
            <span class="weui-form-preview__value">{{
              form.main.vq_register_capital
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.vq_business_scope"
          >
            <label class="weui-form-preview__label">经营范围</label>
            <span class="weui-form-preview__value">{{
              form.main.vq_business_scope
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.vq_manufacturing_capacity"
          >
            <label class="weui-form-preview__label">供货能力</label>
            <span class="weui-form-preview__value">{{
              form.main.vq_manufacturing_capacity
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.vq_ird_daily_capacity"
          >
            <label class="weui-form-preview__label">日产能</label>
            <span class="weui-form-preview__value">{{
              form.main.vq_ird_daily_capacity
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.vq_sales_volume">
            <label class="weui-form-preview__label">年销售额</label>
            <span class="weui-form-preview__value">{{
              form.main.vq_sales_volume
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.vq_staff">
            <label class="weui-form-preview__label">公司人数</label>
            <span class="weui-form-preview__value">{{
              form.main.vq_staff
            }}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商联系人</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ item.vc_name }} {{ item.vc_tel }}
                <call-mobile :mobile="item.vc_tel"></call-mobile>
              </span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.vq_qa_status">
            <label class="weui-form-preview__label">品质意见</label>
            <span class="weui-form-preview__value"
              >{{ vq_qa_score || 0 }}分 {{ form.main.vq_qa_status
              }}<span v-if="form.main.vq_qa_opinion">
                {{ vq_qa_opinion }}</span
              ></span
            >
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.vq_develop_status"
          >
            <label class="weui-form-preview__label">研发意见</label>
            <span class="weui-form-preview__value"
              >{{ vq_develop_score || 0 }}分 {{ form.main.vq_develop_status
              }}<span v-if="form.main.vq_develop_opinion">
                {{ vq_develop_opinion }}</span
              ></span
            >
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.vq_engineer_status"
          >
            <label class="weui-form-preview__label">工程意见</label>
            <span class="weui-form-preview__value"
              >{{ vq_engineer_score || 0 }}分 {{ form.main.vq_engineer_status
              }}<span v-if="form.main.vq_engineer_opinion">
                {{ vq_engineer_opinion }}</span
              ></span
            >
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.vq_purchase_status"
          >
            <label class="weui-form-preview__label">采购意见</label>
            <span class="weui-form-preview__value"
              >{{ vq_purchase_score || 0 }}分 {{ form.main.vq_purchase_status
              }}<span v-if="form.main.vq_purchase_opinion">
                {{ vq_purchase_opinion }}</span
              ></span
            >
          </div>
          <div class="weui-form-preview__item" v-if="form.main.vq_review">
            <label class="weui-form-preview__label">综合结论</label>
            <span class="weui-form-preview__value"
              >{{ vq_review_score || 0 }}分 {{ form.main.vq_review }}</span
            >
          </div>
        </div>
      </div>

      <file-list v-model="form.main.vq_attach" />
    </div>
  </div>
</template>

<script>
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    FileList,
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/sample/vendorQualifications",
    };
  },
};
</script>